import { useState } from "react";
import { Plus, Search, Pencil, Trash2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useApi } from "../lib/api";
import { PageHead, Input, Textarea, Field, Btn, Card, DataList } from "../components/kit";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { waLink } from "../lib/constants";

function CustomerDialog({ c, onClose, onSaved }) {
  const [f, setF] = useState(c);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      f.id ? await api.put(`/customers/${f.id}`, f) : await api.post("/customers", f);
      toast.success("Pelanggan disimpan");
      onSaved();
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="customer-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Edit Pelanggan" : "Pelanggan Baru"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Field label="Nama"><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="cust-name-input" /></Field>
          <Field label="No. WhatsApp"><Input type="tel" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} data-testid="cust-wa-input" /></Field>
          <Field label="Alamat"><Textarea rows={2} value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="cust-address-input" /></Field>
          <Btn type="submit" loading={busy} className="w-full" data-testid="cust-save-btn">Simpan</Btn>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default function Customers() {
  const [q, setQ] = useState("");
  const [edit, setEdit] = useState(null);
  const { data, mutate } = useApi(`/customers?q=${encodeURIComponent(q)}`);
  const del = async (c) => {
    if (!window.confirm(`Hapus pelanggan ${c.name}?`)) return;
    try { await api.delete(`/customers/${c.id}`); toast.success("Pelanggan dihapus"); mutate(); } catch (x) { toast.error(errMsg(x)); }
  };
  return (
    <>
      <PageHead title="Pelanggan" sub="Data pelanggan tersimpan" action={<Btn onClick={() => setEdit({ name: "", whatsapp: "", address: "" })} data-testid="add-customer-btn"><Plus className="w-5 h-5" /> <span className="hidden sm:inline">Pelanggan</span></Btn>} />
      <div className="relative"><Search className="w-5 h-5 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" /><Input className="pl-11" placeholder="Cari nama" value={q} onChange={(e) => setQ(e.target.value)} data-testid="customer-search-input" /></div>
      <DataList data={data} emptyText="Belum ada pelanggan." emptyTestId="customers-empty">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="customer-list">
          {(data || []).map((c) => (
            <Card key={c.id} className="space-y-1" data-testid={`customer-${c.id}`}>
              <div className="font-bold text-lg">{c.name}</div>
              <div className="text-sm text-slate-600">{c.whatsapp || "-"}</div>
              <div className="text-sm text-slate-500 line-clamp-2">{c.address || "-"}</div>
              <div className="flex gap-2 pt-2">
                {c.whatsapp && <a href={waLink(c.whatsapp)} target="_blank" rel="noreferrer" className="h-11 w-11 grid place-items-center rounded-xl bg-emerald-50 text-emerald-600"><MessageCircle className="w-5 h-5" /></a>}
                <button onClick={() => setEdit(c)} className="h-11 w-11 grid place-items-center rounded-xl bg-slate-100" data-testid={`edit-customer-${c.id}`}><Pencil className="w-5 h-5" /></button>
                <button onClick={() => del(c)} className="h-11 w-11 grid place-items-center rounded-xl bg-rose-50 text-rose-600" data-testid={`delete-customer-${c.id}`}><Trash2 className="w-5 h-5" /></button>
              </div>
            </Card>
          ))}
        </div>
      </DataList>
      {edit && <CustomerDialog c={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); mutate(); }} />}
    </>
  );
}
